module.exports = "<popover\r\n\t#popover\r\n\t[hasChanges]=\"hasChanges\"\r\n\t[disabled]=\"disabled\"\r\n\t(onShow)=\"onShow()\"\r\n\t(onSave)=\"onSave($event)\"\r\n\t(onCancel)=\"onCancel()\"\r\n\t[name]=\"name\"\r\n\t[placement]=\"placement\">\r\n\t\r\n\t{{originalValue}}\r\n\r\n\t<input edit\r\n\t\t#focus\r\n\t\tclass=\"form-control\"\r\n\t\ttype=\"text\"\r\n\t\t[(ngModel)]=\"dirtyValue\"\r\n\t\t(keyup.Escape)=\"popover.onCancel()\"\r\n\t\t(keyup.enter)=\"popover.onSave()\"/>\r\n</popover>";


//////////////////
// WEBPACK FOOTER
// ./TypeScript/shared/editable-popover/popover-text.template.html
// module id = 422
// module chunks = 10